import { render, staticRenderFns } from "./BandwichItem.vue?vue&type=template&id=c8214d62&scoped=true&"
import script from "./BandwichItem.vue?vue&type=script&lang=js&"
export * from "./BandwichItem.vue?vue&type=script&lang=js&"
import style0 from "./BandwichItem.vue?vue&type=style&index=0&id=c8214d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8214d62",
  null
  
)

export default component.exports